import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import formatCurrency from 'format-currency';
import {
  setShowEditBookingContactInformation,
  DEVICES,
  setIsEditingBooking,
} from '../../../actions/Booking';
import { setOpenReservationDetails } from '../../../actions/Session';
import './BookingOverview.css';
import {
  FinalRoomsAmount,
} from '../utils';
import {
  convertCoinsToCurrencyUsingRoundedConversionRate,
} from '../../../utils';
//import { getLangValue } from '../../../utils/Generic';

// eslint-disable-next-line no-unused-vars
const BookingOverview = (props, context) => {
  if (props.hotel == null) {
    return null;
  }

  const navigate = useNavigate();

  const onChangeRoomsClick = () => {
    props.dispatch(setIsEditingBooking(true));
    props.dispatch(setOpenReservationDetails(false));
    navigate('/rooms/');
  };

  const onChangeBookingContactInformationClick = () => {
    props.dispatch(setShowEditBookingContactInformation(true));
  };

  // Todo ésto lo saqué de ReservationDetailsBlock
  // Ahí está contenido todo esto que se necesita para mostrar las distintas cantidades totales y de cada cuarto
  // No se alteró nada, sino que sólo se tomó de ahí
  // Ver la posibilidad de encapsular en métodos y meterlo en otro archivo para reusar en ambas partes
  // Se podría meter en un archivo para reusarlo
  let rateCodePrimeroSeleccionado = null;
  //let boardCodePrimeroSeleccionado = null;
  let rateCurrencyCodePrimeroSeleccionado = null;

  const roomData = props.multipleRoomSelection;

  // Iterar sobre las claves numéricas y encontrar el primer cuarto seleccionado
  const foundKey = Object.keys(roomData).find((k) => roomData[k] && roomData[k].rateCode);
  if (foundKey !== undefined) {
    rateCodePrimeroSeleccionado = roomData[foundKey].rateCode;
    //boardCodePrimeroSeleccionado = roomData[foundKey].boardCode;
  }

  // Buscar el rate correspondiente al rateCode encontrado
  //let rateNamePrimeroSeleccionado = null;

  if (rateCodePrimeroSeleccionado) {
    const firstValidRoomKey = ['1', '2', '3', '4'].find((key) => roomData[key] !== null);
    const rates = firstValidRoomKey ? roomData[firstValidRoomKey].room.rates : [];// Accediendo a los rates del primer cuarto seleccionado
    for (let i = 0; i < rates.length; i++) {
      if (rates[i].code === rateCodePrimeroSeleccionado) {
        //rateNamePrimeroSeleccionado = rates[i].name;
        rateCurrencyCodePrimeroSeleccionado = rates[i].currency;
        break;
      }
    }
  }
  /*let boardNamePrimeroSeleccionado = null;
  if (rateCodePrimeroSeleccionado) {
    const firstValidRoomKey = ['1', '2', '3', '4'].find((key) => roomData[key] !== null);
    const rates = firstValidRoomKey ? roomData[firstValidRoomKey].room.rates : [];// Accediendo a los rates del primer cuarto seleccionado
    for (let i = 0; i < rates.length; i++) {
      if (rates[i].code === rateCodePrimeroSeleccionado) {
        const { boards } = rates[i];
        for (let j = 0; j < boards.length; j++) {
          if (boards[j].code === boardCodePrimeroSeleccionado) {
            boardNamePrimeroSeleccionado = getLangValue(boards[j], props.lang, 'name');
          }
        }
        break;
      }
    }
  }*/

  const getFractionDigits = () => {
    //Pidieron que quieren ver los costos redondeados cuando la moneda no sea la de la reserva
    const fractionDigits = {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    };
    if (rateCurrencyCodePrimeroSeleccionado != null && props.hotel.round_amounts_for_display_enabled === true) {
      fractionDigits.minimumFractionDigits = rateCurrencyCodePrimeroSeleccionado === props.currency.code ? 2 : 0;
      fractionDigits.maximumFractionDigits = rateCurrencyCodePrimeroSeleccionado === props.currency.code ? 2 : 0;
    }
    return fractionDigits;
  };

  const fractionDigits = getFractionDigits();

  const showFinalAmountLoggedInNewMemberTrue = () => {
    //Cuando el usuario está logeado y está activado newMemberDiscountPercentage y newMember es true
    const {
      isLoyaltyUserLoggedIn, new_member_discount_percentage_activated, new_member, coinsApplied, currencies, cart,
    } = props;
    // Obtener la moneda personalizada
    const customCurrency = currencies.find((element) => element.code === cart.custom_currency_code);
    // Calcular los valores intermedios
    const originalAmount = cart.amount[cart.custom_currency_code];
    const finalCoinsApplied = props.isEditingBooking || props.isInBookingDetailsPage === true
      ? props.coinsUsedInEditingBooking : coinsApplied;
    //Acá ponemos la cantidad de coins que tengamos en la reserva a editar
    const coinsConverted = convertCoinsToCurrencyUsingRoundedConversionRate(finalCoinsApplied, customCurrency);
    const discountAmount = (
      FinalRoomsAmount(props, cart.custom_currency_code, false).totalAmount
      * (props.new_member_discount_percentage / 100)
    );
    // Verificar si el usuario tiene derecho al descuento
    const isEligibleForDiscount = isLoyaltyUserLoggedIn && new_member_discount_percentage_activated && new_member;
    // Calcular el monto final con descuento y monedas aplicadas
    let finalAmount = isEligibleForDiscount
      ? originalAmount - coinsConverted - discountAmount
      : originalAmount;
    if (props.isInBookingDetailsPage === true) {
      finalAmount = isEligibleForDiscount
        ? originalAmount - discountAmount
        : originalAmount;
      // Cuando la reserva ya está creada, el costo de los coins
      // ya están incluídos en el costo de la reserva
      // machacar el precio
    }
    // Si el monto final es negativo, aseguramos que sea 0
    const amountToDisplay = finalAmount > 0 ? finalAmount : 0;
    // Renderizado condicional
    return (
      <Fragment>
        {isEligibleForDiscount && (
          <span>
            {formatCurrency(amountToDisplay, {
              ...customCurrency,
              minimumFractionDigits: fractionDigits.minimumFractionDigits,
              maximumFractionDigits: fractionDigits.maximumFractionDigits,
            })}
          </span>
        )}
      </Fragment>
    );
  };

  const showFinalAmountLoggedInNewMemberFalse = () => {
    //Cuando el usuario está logeado y newMemberDiscountPecentage está desactivado o newMember es falso
    //Pidieron que quieren ver los costos redondeados cuando la moneda no sea la de la reserva

    const {
      isLoyaltyUserLoggedIn, new_member_discount_percentage_activated, new_member, coinsApplied, currency,
    } = props;
    const finalAmount = FinalRoomsAmount(props).totalAmount;
    const finalCoinsApplied = (props.isEditingBooking || props.isInBookingDetailsPage)
      ? props.coinsUsedInEditingBooking : coinsApplied;
    //Acá ponemos la cantidad de coins que tengamos en la reserva a editar
    const coinsConverted = convertCoinsToCurrencyUsingRoundedConversionRate(finalCoinsApplied, currency);
    // Comprobar si el usuario está logueado y no tiene descuento o no es nuevo miembro
    const isEligibleForDiscount = isLoyaltyUserLoggedIn
      && (new_member_discount_percentage_activated === false || new_member === false);
    let amountToDisplay;

    if (isEligibleForDiscount) {
      // Calcular el monto después de aplicar las monedas
      const discountedAmount = finalAmount - coinsConverted;
      // Asegurarse de que el valor no sea negativo
      amountToDisplay = discountedAmount > 0 ? discountedAmount : 0;
    } else {
      // Si no es elegible, mostrar el monto original
      amountToDisplay = finalAmount;
    }
    amountToDisplay += FinalRoomsAmount(props).totalAmountExtras;
    return (
      <Fragment>
        {isEligibleForDiscount && (
          <span>
            {formatCurrency(amountToDisplay, {
              ...currency,
              minimumFractionDigits: fractionDigits.minimumFractionDigits,
              maximumFractionDigits: fractionDigits.maximumFractionDigits,
            })}
          </span>
        )}
      </Fragment>
    );
  };

  const showFinalAmountNotLoggedIn = () => {
    //Cuando el usuario no está logeado
    //Pidieron que quieren ver los costos redondeados cuando la moneda no sea la de la reserva

    const { isLoyaltyUserLoggedIn, currency } = props;
    const amountToDisplay = FinalRoomsAmount(props, null, false).totalAmount
    + FinalRoomsAmount(props, null, false).totalAmountExtras;
    const isUserNotLoggedIn = isLoyaltyUserLoggedIn === false;
    return (
      <Fragment>
        {isUserNotLoggedIn && (
          <span>
            {formatCurrency(amountToDisplay, {
              ...currency,
              minimumFractionDigits: fractionDigits.minimumFractionDigits,
              maximumFractionDigits: fractionDigits.maximumFractionDigits,
            })}
          </span>
        )}
      </Fragment>
    );
  };

  const renderInstallmentsText = () => (
        <div className="installments-text-container">
            <div className="installments-title">{context.t('INTEREST FREE INSTALLMENTS')}</div>
            <div className="installments-subtitle">{context.t('(FOR DETAILS, PLEASE CONSULT YOUR BANK)')}</div>
        </div>
  );

  const renderBookingEditBookingTotalPrice = () => {
    //const loyaltyDiscountApplied = Object.keys(props.editBooking.loyalty).includes("discount_applied")? props.editBooking.loyalty.discount_applied: 0;
    //const totalPrice = (props.editBooking.amount - loyaltyDiscountApplied) > 0 ? (props.editBooking.amount - loyaltyDiscountApplied) : 0
    // Revisar si está bien así la cantidad o lo dejamos como arriba
    // En reservation details block sí le quitamos la cantidad de loyalty porque al final mostramos cuando queda por pagar
    // pero en booking overview arriba ponemo el total y luego decimos el remaining amount, además de mostrar el loyalty discount aparte
    let totalPrice = props.editBooking.amount;
    if (props.editBooking != null && props.editBooking.agent_code != null && props.editBooking.agent_code !== ''
      && props.editBooking.agent_sell != null && props.editBooking.agent_sell === true
      && props.editBooking.rate_type === 'NET_RATE' && props.editBooking.who_is_viewing === 'CLIENT') {
      totalPrice = props.editBooking.amount_public;
    }
    return (
      <Fragment>
        <span>
          {formatCurrency(totalPrice, {
            ...props.editBooking.currency,
            minimumFractionDigits: fractionDigits.minimumFractionDigits,
            maximumFractionDigits: fractionDigits.maximumFractionDigits,
          })}
        </span>
      </Fragment>
    );
  };

  const RoomAmount = (selectedBoard, room) => {
    const amountObject = {
      amount: 0,
      discount: 0,
    };
    if (props.mostrarExtras === false) {
      if (selectedBoard != null) {
        /* Ésto regresa un objeto así:
        {
            "amount": 11941.02,
            "amount_before": 22113,
            "discount": 46,
            "promocode_discount": 0
        }*/
        amountObject.amount = selectedBoard.amount[props.currency.code].amount;
        amountObject.discount = selectedBoard.amount[props.currency.code].discount;
        return amountObject;
      }
    } else {
      amountObject.amount = room.amount[props.currency.code];
      const amount = room.amount[props.currency.code];
      const amount_before = room.amount_before[props.currency.code];
      // Calculate the discount amount
      const discountAmount = amount_before - amount;
      // Calculate the discount percentage
      const discountPercentage = (discountAmount / amount_before) * 100;
      amountObject.discount = parseInt(discountPercentage, 10);
      return amountObject;
    }
    return null;
  };
  let reservationStatus = props.editBooking.status_display;
  if (window.location.pathname === '/confirmation/') {
    reservationStatus = context.t('Confirm the changes to apply the update');
  }
  return (
    <div className="booking_overview_container">
      <h1 className="booking_overview_title">{context.t('BOOKING DETAILS')}</h1>

      <div className="booking_overview_details">
        <div className="booking_overview_detail_section">
          <div className="booking_overview_detail_item">
            <span className="booking_overview_detail_label">{context.t('Confirmation Number:')}</span>
            <span className="booking_overview_detail_value">{props.editBooking.locator}</span>
          </div>
          <div className="booking_overview_detail_item">
            <span className="booking_overview_detail_label">{context.t('Reservation Status:')}</span>
            <span className="booking_overview_detail_value">{reservationStatus}</span>
          </div>
          <div className="booking_overview_detail_item total-price-container">
            <span className="booking_overview_detail_label">{context.t('Total Price:')}</span>
            <div className="total-price-value-container">
                <span className="booking_overview_detail_value">
                    {props.isInBookingDetailsPage === false && (
                        <>
                        {showFinalAmountLoggedInNewMemberTrue(true)}
                        {showFinalAmountLoggedInNewMemberFalse()}
                        {showFinalAmountNotLoggedIn()}
                        </>
                    )}
                    {props.isInBookingDetailsPage === true && renderBookingEditBookingTotalPrice()}
                </span>
                {props.editBooking.payment_installments_value != null
                  && props.editBooking.payment_installments_value > 1
                  && renderInstallmentsText()}
            </div>
          </div>
          {/*Se muestra siempre que no sea agentCode con agentSell true*/}
          {!(props.agentCode !== '' && props.agentSell === 'true')
            && <div className="booking_overview_detail_item">
              <span className="booking_overview_detail_label">{props.agentCode !== '' && props.agentSell === 'false' ? context.t('Sandos Advisors Coins Used:') : context.t('Loyalty Coins Used:')}</span>
              <span className="booking_overview_detail_value">{props.editBooking.loyalty.coins_used
                ? props.editBooking.loyalty.coins_used : 0} {context.t('Coins')} ({formatCurrency(props.editBooking.loyalty.discount_applied, {
                  ...props.editBooking.currency,
                  minimumFractionDigits: fractionDigits.minimumFractionDigits,
                  maximumFractionDigits: fractionDigits.maximumFractionDigits,
                })})</span>
            </div>
          }
          {
            !(props.editBooking.agent_code != null && props.editBooking.agent_code !== ''
            && props.editBooking.agent_sell != null && props.editBooking.agent_sell === true
            && props.editBooking.rate_type === 'NET_RATE' && props.editBooking.who_is_viewing === 'CLIENT')
            && <>
              <div className="booking_overview_detail_item">
                <span className="booking_overview_detail_label">{context.t('Amount Paid (with payment method):')}</span>
                <span className="booking_overview_detail_value">
                  {formatCurrency(props.editBooking.paid_amount_with_payment_method, {
                    ...props.editBooking.paid_currency,
                    minimumFractionDigits: fractionDigits.minimumFractionDigits,
                    maximumFractionDigits: fractionDigits.maximumFractionDigits,
                  })}
                </span>
              </div>
              <div className="booking_overview_detail_item">
                <span className="booking_overview_detail_label">{context.t('Pending Amount to Pay at the Hotel:')}</span>
                {props.isInBookingDetailsPage === true
                  && <span className="booking_overview_detail_value">
                    {formatCurrency(props.editBooking.remaining_amount, {
                      ...props.editBooking.currency,
                      minimumFractionDigits: fractionDigits.minimumFractionDigits,
                      maximumFractionDigits: fractionDigits.maximumFractionDigits,
                    })}
                  </span>
                }
                {props.isInBookingDetailsPage === false
                  && <span className="booking_overview_detail_value">
                    {props.isInBookingDetailsPage === false && (
                      <>
                        {showFinalAmountLoggedInNewMemberTrue(true)}
                        {showFinalAmountLoggedInNewMemberFalse()}
                        {showFinalAmountNotLoggedIn()}
                      </>
                    )}
                  </span>
                }
              </div>
            </>
          }
        </div>

        {(props.agentCode === '')
          && <div className="booking_overview_loyalty_note">
            {context.t('At check-out, SANDOS4U coins will be added to the account of the SANDOS4U Member who made the reservation. The amount will be calculated based on the percentage corresponding to their membership level, applied to the total stay (excluding taxes).')}
          </div>
        }
        {(props.agentCode !== '' && props.agentSell === 'false')
          && <div className="booking_overview_loyalty_note">
            {context.t('If you paid for your reservation using both coins and money, SA coins will be credited to your account at check-out. The amount will be calculated based on your membership level and only on the money paid, excluding taxes and coins.')}
          </div>
        }

        <div className="booking_overview_detail_section">
          <div className="booking_overview_section_header">
            <h2>{context.t('GUEST INFORMATION')}</h2>
            {(props.editBooking.status === 'CONF' || props.editBooking.status === 'PEND')
              && props.isInBookingDetailsPage
              && props.cart.cartHotel.rooms.length > 0
              && <button className="booking_overview_edit_button"
                onClick={() => onChangeBookingContactInformationClick()}>{context.t('Edit')}</button>}
          </div>
          <div className="booking_overview_detail_item">
            <span className="booking_overview_detail_label">{context.t('Guest Name:')}</span>
            <span className="booking_overview_detail_value">{props.editBooking.cli_full_name}</span>
          </div>
          <div className="booking_overview_detail_item">
            <span className="booking_overview_detail_label">{context.t('Email:')}</span>
            <span className="booking_overview_detail_value">{props.editBooking.cli_email}</span>
          </div>
          <div className="booking_overview_detail_item">
            <span className="booking_overview_detail_label">{context.t('Country:')}</span>
            <span className="booking_overview_detail_value">{props.editBooking.cli_country_name}</span>
          </div>
        </div>

        <div className="booking_overview_detail_section">
          <div className="booking_overview_section_header">
            <h2>{context.t('Check-in / Check-out')}</h2>
          </div>
          <div className="booking_overview_detail_item">
            <span className="booking_overview_detail_label">{context.t('Check-in Time:')}</span>
            <span className="booking_overview_detail_value">{props.editBooking.hotel.arrival_time}</span>
          </div>
          <div className="booking_overview_detail_item">
            <span className="booking_overview_detail_label">{context.t('Check-out Time:')}</span>
            <span className="booking_overview_detail_value">{props.editBooking.hotel.departure_time}</span>
          </div>
        </div>

        <div className="booking_overview_detail_section">
          <div className="booking_overview_section_header">
            <h2>{context.t('ROOM DETAILS')} ({context.t('Total:')} {props.editBooking.rooms.length})</h2>
            {props.cart.cartHotel.rooms.length > 0
              && props.editBooking.rooms[0].rate.name === 'FLEXIBLE'
              && props.editBooking.status === 'CONF'
              && props.isInBookingDetailsPage
              && <button className="booking_overview_edit_button" onClick={() => onChangeRoomsClick()}>{context.t('Edit')}</button>}
          </div>

          {props.isInBookingDetailsPage === true && props.editBooking.rooms.map((room, index) => (
            <div className="booking_overview_room_details" key={`room-${index}`}>
              <h3>{context.t('Room')} {index + 1}</h3>
              <div className="booking_overview_detail_item">
                <span className="booking_overview_detail_label">{context.t('Room Type:')}</span>
                <span className="booking_overview_detail_value">{room.room.name}</span>
              </div>
              <div className="booking_overview_detail_item">
                <span className="booking_overview_detail_label">{context.t('Rate:')}</span>
                <span className="booking_overview_detail_value">
                  {room.rate.name} ({room.rate.code})
                </span>
              </div>
              <div className="booking_overview_detail_item">
                <span className="booking_overview_detail_label">{context.t('Occupants:')}</span>
                <span className="booking_overview_detail_value">
                  {room.distribution.adults} {context.t('Adults')}
                  {room.distribution.children > 0 ? `, ${room.distribution.children} children` : ''}
                </span>
              </div>
              <div className="booking_overview_detail_item">
                <span className="booking_overview_detail_label">{context.t('Plan:')}</span>
                <span className="booking_overview_detail_value">{room.board.name}</span>
              </div>
              <div className="booking_overview_detail_item">
                <span className="booking_overview_detail_label">{context.t('Arrival Date:')}</span>
                <span className="booking_overview_detail_value">
                  {moment(room.check_in).format('LL')}
                </span>
              </div>
              <div className="booking_overview_detail_item">
                <span className="booking_overview_detail_label">{context.t('Departure Date:')}</span>
                <span className="booking_overview_detail_value">
                  {moment(room.check_out).format('LL')}
                </span>
              </div>
              { !(props.editBooking.agent_code != null && props.editBooking.agent_code !== ''
                && props.editBooking.agent_sell != null && props.editBooking.agent_sell === true)
                && <div className="booking_overview_detail_item">
                  <span className="booking_overview_detail_label">{context.t('Room amount:')}</span>
                  <span className="booking_overview_detail_value">
                    {formatCurrency(room.amount, {
                      ...room.currency,
                      minimumFractionDigits: fractionDigits.minimumFractionDigits,
                      maximumFractionDigits: fractionDigits.maximumFractionDigits,
                    })}
                  </span>
                </div>
              }
              { (props.editBooking.agent_code != null && props.editBooking.agent_code !== ''
                && props.editBooking.agent_sell != null && props.editBooking.agent_sell === true
                && props.editBooking.who_is_viewing === 'CLIENT')
                && <div className="booking_overview_detail_item">
                  <span className="booking_overview_detail_label">{context.t('Room amount:')}</span>
                  <span className="booking_overview_detail_value">
                    {formatCurrency(room.amount_public, {
                      ...room.currency,
                      minimumFractionDigits: fractionDigits.minimumFractionDigits,
                      maximumFractionDigits: fractionDigits.maximumFractionDigits,
                    })}
                  </span>
                </div>
              }
              { (props.editBooking.agent_code != null && props.editBooking.agent_code !== ''
              && props.editBooking.agent_sell != null && props.editBooking.agent_sell === true
              && props.editBooking.who_is_viewing === 'AGENT')
              && <>
                <div className="booking_overview_detail_item">
                  <span className="booking_overview_detail_label">{context.t('Room amount (client):')}</span>
                  <span className="booking_overview_detail_value">
                    {formatCurrency(room.amount_public, {
                      ...room.currency,
                      minimumFractionDigits: fractionDigits.minimumFractionDigits,
                      maximumFractionDigits: fractionDigits.maximumFractionDigits,
                    })}
                  </span>
                </div>
                <div className="booking_overview_detail_item">
                  <span className="booking_overview_detail_label">{context.t('Room amount (agent):')}</span>
                  <span className="booking_overview_detail_value">
                    {formatCurrency(room.amount, {
                      ...room.currency,
                      minimumFractionDigits: fractionDigits.minimumFractionDigits,
                      maximumFractionDigits: fractionDigits.maximumFractionDigits,
                    })}
                  </span>
                </div>
              </>
              }
            </div>
          ))}

          {props.isInBookingDetailsPage === false && props.cart.cartHotel.rooms.map((room, index) => (
            <div className="booking_overview_room_details" key={`room-${index}`}>
              <h3>{context.t('Room')} {index + 1}</h3>
              <div className="booking_overview_detail_item">
                <span className="booking_overview_detail_label">{context.t('Room Type:')}</span>
                <span className="booking_overview_detail_value">{room.room.name}</span>
              </div>
              <div className="booking_overview_detail_item">
                <span className="booking_overview_detail_label">{context.t('Rate:')}</span>
                <span className="booking_overview_detail_value">
                  {room.rate.name} ({room.rate.code})
                </span>
              </div>
              <div className="booking_overview_detail_item">
                <span className="booking_overview_detail_label">{context.t('Occupants:')}</span>
                <span className="booking_overview_detail_value">
                  {room.distribution.adults} {context.t('Adults')}
                  {room.distribution.children > 0 ? `, ${room.distribution.children} children` : ''}
                </span>
              </div>
              <div className="booking_overview_detail_item">
                <span className="booking_overview_detail_label">{context.t('Plan:')}</span>
                <span className="booking_overview_detail_value">{room.board.name}</span>
              </div>
              <div className="booking_overview_detail_item">
                <span className="booking_overview_detail_label">{context.t('Arrival Date:')}</span>
                <span className="booking_overview_detail_value">
                  {moment(room.checkIn).format('LL')}
                </span>
              </div>
              <div className="booking_overview_detail_item">
                <span className="booking_overview_detail_label">{context.t('Departure Date:')}</span>
                <span className="booking_overview_detail_value">
                  {moment(room.checkOut).format('LL')}
                </span>
              </div>
              <div className="booking_overview_detail_item">
                <span className="booking_overview_detail_label">{context.t('Room amount:')}</span>
                <span className="booking_overview_detail_value">
                  {formatCurrency(RoomAmount(room.board, room).amount, {
                    ...props.currency,
                    minimumFractionDigits: fractionDigits.minimumFractionDigits,
                    maximumFractionDigits: fractionDigits.maximumFractionDigits,
                  })}
                </span>
              </div>
            </div>
          ))}
        </div>

        <div className="booking_overview_detail_section">
          <div className="booking_overview_section_header">
            <h2>{context.t('UPGRADES/EXTRAS DETAILS')}</h2>
          </div>
          <div className="booking_overview_extras_note">
            {context.t('(Please inquire at the front desk for more information about available upgrades and extras).')}
            {context.t('If you have any questions or special requests, please do not hesitate to contact us.')}
            {context.t('We hope you enjoy your stay at {hotel_name}!', { hotel_name: props.editBooking.hotel.name })}
          </div>
        </div>
      </div>

      <div className="booking_overview_best_rate_options">
        <h2>{context.t('Our best rate options for your reservation')}</h2>
      </div>
    </div>
  );
};

BookingOverview.propTypes = {

};

BookingOverview.contextTypes = {
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const { memberInfo } = state.loyalty;
  const isEmailPresent = Boolean(memberInfo && memberInfo.accountHolder);
  const isBecomeMemberStatus = state.loyalty.selectedStatus === 'becomeMember';

  return {
    hotel: state.booking.hotel,
    loyaltyName: state.session.chainData.booking_engine_configuration.loyalty_name,
    openReservationDetails: state.session.openReservationDetails,
    shouldShowNewShoppingCartMobileHeader: !!(window.location.pathname === '/rooms/'
      || window.location.pathname === '/confirmation/'),
    multipleRoomStep: state.booking.multipleRoomStep,
    multipleRoomSelection: state.booking.multipleRoomSelection,
    cart: state.cart,
    currency: state.booking.filterCurrency,
    nights: state.booking.last_requested_info.nights,
    chain: state.bookingFormState.chain,
    lang: state.i18nState.lang,
    isCreatingBooking: state.session.isCreatingBooking,
    isMobile: state.booking.device === DEVICES.MOBILE,
    isTabletV: state.booking.device === DEVICES.TABLETV,
    isTabletH: state.booking.device === DEVICES.TABLETH,
    isDesktop: state.booking.device === DEVICES.DESKTOP,
    selectedStatus: state.loyalty.selectedStatus,
    conversionRates: state.loyalty.conversionRates,
    distributions: state.bookingFormState.distributions.length > 0
      ? state.bookingFormState.distributions
      : state.cart.cartHotel.rooms.map((room) => room.distribution),
    coinsApplied: state.loyalty.coinsApplied,
    coinsEntered: state.loyalty.coinsEntered,
    isLoyaltyUserLoggedIn: isEmailPresent || isBecomeMemberStatus,
    new_member: state.loyalty.newMember,
    new_member_discount_percentage: state.loyalty.newMemberDiscountPercentage,
    new_member_discount_percentage_activated: state.booking.hotel != null
      ? (state.booking.hotel.new_member_discount_percentage_activated === true
      && state.bookingFormState.agentSell === 'false') : false,
    isCartUpdating: state.cart.isUpdating,
    currencies: state.booking.currencies,
    loggedUser: state.loyalty.loggedUser,
    memberInfo,
    maxPercentUsage: state.loyalty.maxPercentUsage,
    promoCode: state.bookingFormState.promoCode,
    locator: state.booking.book_locator,
    isEditingBooking: state.booking.isEditingBooking,
    editBooking: state.booking.editBooking,
    coinsUsedInEditingBooking: state.booking.coinsUsedInEditingBooking,
    isInBookingDetailsPage: window.location.pathname.includes('/thanks/')
    || window.location.pathname.includes('/my-booking/')
    || window.location.pathname.includes('/booking-detail/'),
    agentCode: state.bookingFormState.agentCode,
    agentSell: state.bookingFormState.agentSell,
  };
};

export default connect(mapStateToProps)(BookingOverview);
